/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { first, map } from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { Link } from '@bingads-webui-react/fabric-with-signal';
import { getTitlePreview, getDescPreview } from '@bingads-webui-campaign/summary-grid-helper';
import { getExpandedTextAdDisplayUrl } from '@bingads-webui-campaign-legacy/crud-ad/service/displayUrl';

export const ResponsiveSearchAdPreview = ({ ad, i18n }) => {
  const resultData = useMemo(() => {
    const convertedFinalUrl = first(ad.FinalUrls);
    const headlineList = map(ad.Headlines, i => ({
      Text: i.Asset && i.Asset.Text,
      PinnedField: i.PinnedField,
    }));
    const descriptionList = map(ad.Descriptions, i => ({
      Text: i.Asset && i.Asset.Text,
      PinnedField: i.PinnedField,
    }));
    const convertedTitle = getTitlePreview(headlineList);
    const convertedText = getDescPreview(descriptionList);
    const convertedDisplayUrl = getExpandedTextAdDisplayUrl(first(ad.FinalUrls), ad.DisplayUrl, ad.Path1, ad.Path2);
    return {
      convertedFinalUrl,
      convertedTitle,
      convertedText,
      convertedDisplayUrl,
    };
  }, [ad]);

  return (
    <div className="rsa-ad-preview-content-container">
      <Text block>
        <Link className="ad-title-preview" target="_blank" href={resultData.convertedFinalUrl}>{resultData.convertedTitle}</Link>
      </Text>
      <Text block nowrap className="ad-url-line">
        <Link className="ad-url-preview">{resultData.convertedDisplayUrl}</Link>
      </Text>
      <Text block className="ad-description-preview">
        <span className="ad-slug">{i18n.getString(_TL_('Ad'))}</span>
        {resultData.convertedText}
      </Text>
    </div>
  );
};

ResponsiveSearchAdPreview.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ad: PropTypes.shape({
    FinalUrls: PropTypes.arrayOf(PropTypes.string),
    Headlines: PropTypes.arrayOf(PropTypes.shape({
      Asset: PropTypes.shape({
        Text: PropTypes.string,
      }),
      PinnedField: PropTypes.string,
    })),
    Descriptions: PropTypes.arrayOf(PropTypes.shape({
      Asset: PropTypes.shape({
        Text: PropTypes.string,
      }),
      PinnedField: PropTypes.string,
    })),
    DisplayUrl: PropTypes.string,
    Path1: PropTypes.string,
    Path2: PropTypes.string,
  }),
};

ResponsiveSearchAdPreview.defaultProps = {
  ad: {
    FinalUrls: [],
    Headlines: [],
    Descriptions: [],
    DisplayUrl: '',
    Path1: '',
    Path2: '',
  },
};
